import styled from 'styled-components';

export const BottomNavWrapper = styled.nav`
    position: fixed;
    bottom: -2px;
    left: 0;
    right: 0;
    padding: 0.8125rem 0;
    background-color: #121212;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 1000;
    border-top: 0.09375rem solid rgba(255, 255, 255, 0.1);

    @media (min-width: 768px) {
        display: none;
    }
`;
